import { QueryClient } from "@tanstack/react-query";

export const PUBLIC_STALE_TIME_MS = 5 * 60 * 1000;
export const PUBLIC_GC_TIME_MS = 30 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: PUBLIC_STALE_TIME_MS,
      gcTime: PUBLIC_GC_TIME_MS,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
